'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import useAiSidebar from './useAiSidebar';
import { IAiSidebarState } from '@/creditflowresearch/domain/vo/AiSidebar';
import { INITIAL_AI_SIDEBAR_STATE } from './constants';

type AiSidebarContextType = ReturnType<typeof useAiSidebar>;

const AiSidebarContext = createContext<AiSidebarContextType | null>(null);

export const useAiSidebarContext = () => {
  const context = useContext(AiSidebarContext);

  if (!context) {
    throw new Error('useAiSidebarContext must be used within an AiSidebarContextProvider');
  }

  return context;
};

interface IProps extends PropsWithChildren {
  initialState?: IAiSidebarState,
}

const AiSidebarContextProvider = ({ children, initialState = INITIAL_AI_SIDEBAR_STATE }: IProps) => (
  <AiSidebarContext.Provider value={ useAiSidebar(initialState) }>
    { children }
  </AiSidebarContext.Provider>
);

export default AiSidebarContextProvider;
